// v414.80 — Video Library: curated clips shown on the distributor portal
// (/video-library) and every public storefront (/{code}/videos).
// Files are re-hosted in our object storage and streamed by the backend
// with Range support (iOS inline playback). Original file names preserved.
const F = `${process.env.REACT_APP_BACKEND_URL}/api/videos`;

// section/title fields are i18n keys under "library.*"
export const LIBRARY_SECTIONS = [
  {
    key: "getting_started",
    videos: [
      { id: "recon-en", title: "library.v_recon", lang: "en", dur: 68, url: `${F}/11b2d735988248cfae97c47baedd7229_final_v11.mp4` },
      { id: "recon-ru", title: "library.v_recon", lang: "ru", dur: 57, url: `${F}/ee665a089ae648bb8eed95c1b34d2f4b_reconstitution_guide_ru.mp4` },
      { id: "recon-fr", title: "library.v_recon", lang: "fr", dur: 55, url: `${F}/65d2e57beaf643e58603d7c9df2bfeba_reconstitution_guide_fr.mp4` },
      { id: "recon-es", title: "library.v_recon", lang: "es", dur: 55, url: `${F}/0d452c643a644fdc882e3faf05b75f37_reconstitution_guide_es.mp4` },
    ],
  },
  {
    key: "nasal",
    videos: [
      { id: "nasal-en", title: "library.v_nasal", lang: "en", url: `${F}/a686de62dd964194952b65473063e034_axisnasal-v1.mp4` },
      { id: "nasal-ru", title: "library.v_nasal", lang: "ru", url: `${F}/09bf758a66de46e69b0b36bde558394f_axisnasal-v2_ru.mp4` },
      { id: "nasal-fr", title: "library.v_nasal", lang: "fr", url: `${F}/74505d1fdafe40d081ffd6f806fa6053_axisnasal-v2_fr.mp4` },
      { id: "nasal-es", title: "library.v_nasal", lang: "es", dur: 42, url: `${F}/ccbe3dc1940d4acd95031d770d2cbf7d_axisnasal-v2_es.mp4` },
    ],
  },
  {
    key: "womens",
    videos: [
      { id: "womens-en", title: "library.v_womens", lang: "en", dur: 46, url: `${F}/d88caaac7fc740ce87ea2a5fe49648fa_final_promo_elder.mp4` },
      { id: "womens-ru", title: "library.v_womens", lang: "ru", dur: 64, url: `${F}/e8d633dcbeae49ab83b128afe2f58a40_final.mp4` },
      { id: "womens-es", title: "library.v_womens", lang: "es", dur: 58, url: `${F}/d1291102ed8e427cb36871d8cece017a_womens_intro_es.mp4` },
    ],
  },
];
